import { ApiError } from "../api";
import getErrorMessage from "./getErrorMessage";

/**
 * Helper to check if an error indicates the token is expired or invalid.
 * We only want to logout when the token itself is bad, not for permission/access issues
 * or server/network errors.
 */
const isTokenExpiredOrInvalid = (error: unknown): boolean => {
  // Check for ApiError with 401 status
  if (error instanceof ApiError && error.status === 401) {
    return true;
  }

  // Check for error object with status property
  if (typeof error === "object" && error !== null && "status" in error) {
    if (error.status === 401) {
      return true;
    }
  }

  // Get message from error
  const message = getErrorMessage(error, "").toLowerCase();

  // Check for specific token-related error messages from Strapi
  return (
    message.includes("invalid token") ||
    message.includes("token expired") ||
    message.includes("jwt expired") ||
    message.includes("jwt malformed") ||
    message.includes("missing or invalid credentials")
  );
};

export default isTokenExpiredOrInvalid;
